import { useAuthUser } from '@/modules/Auth'

export const useAuthUserSubscription = () => {
  const { authUser } = useAuthUser()
  return authUser?.pointSubscription
}
